import { render, staticRenderFns } from "./gameTaskConfig.vue?vue&type=template&id=6b2d9b3e&"
import script from "./gameTaskConfig.vue?vue&type=script&lang=js&"
export * from "./gameTaskConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2d9b3e')) {
      api.createRecord('6b2d9b3e', component.options)
    } else {
      api.reload('6b2d9b3e', component.options)
    }
    module.hot.accept("./gameTaskConfig.vue?vue&type=template&id=6b2d9b3e&", function () {
      api.rerender('6b2d9b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameTaskConfig.vue"
export default component.exports